<template>
  <div>
    <CModal
        size="lg"
        add-content-classes="bg-style2"
        :title="this.dialog.title"
        :color="this.dialog.color"
        :show.sync="this.$props.dialog"
        :centered="true"
        :close-on-backdrop="false"
    >
      <template #header-wrapper>
        <div ></div>
      </template>
      <template #body-wrapper>
        <CCard class="mb-0 bg-style2 text-dark">
          <CCardHeader class="bg-gradient-danger text-white" style="border-top-left-radius: 1rem; border-top-right-radius: 1rem ">
            <span  class="font-weight-bold h6"><CIcon name="cil-layers" size="lg"/> Method </span>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol col="12">
                <CSelect label='Method '
                         :horizontal="{label: 'col-sm-2 font-weight-bold', input: 'col-sm-10'}"
                         @update:value="onSelectMethod"
                         :options="option.methods"/>
              </CCol>
            </CRow>

            <CDropdownDivider/>

            <CRow v-for="objs in item.methods" :key="objs" >
              <CCol>
                <CRow>
                  <CCol class="font-weight-bold">
                    {{objs.title}}
                  </CCol>
                </CRow>
                <CDropdownDivider/>

                <CRow class="mt-3">
                  <CCol col="4" v-for="item in objs.value" :key="item">
                    <CInput addInputClasses="text-right" :type="item.type" :prepend="item.title" v-model="item.value"></CInput>
                  </CCol>
                </CRow>

                <CRow v-if="objs.control.length > 0">
                  <CCol class="font-weight-bold">
                    {{objs.subTitle}}
                  </CCol>
                </CRow>
                <CDropdownDivider/>

                <CRow class="mt-3">
                  <CCol col="4" v-for="item in objs.control" :key="item">
                    <CRow>
                      <CCol class="">
                        <CInput addInputClasses="text-right" :type="item.type" :prepend="item.title" v-model="item.value">
                          <template #append >
                            <!--                            <CButton type="submit" color="primary">Submit</CButton>-->
                            <CInput addInputClasses="p-0" type="color"  v-model="item.color" style="width: 35px"></CInput>
                          </template>
                        </CInput>
                      </CCol>
                      <!--                      <CCol col="2" class="p-0">-->
                      <!--                        <CInput addInputClasses="p-0" type="color"  v-model="item.color"></CInput>-->
                      <!--                      </CCol>-->
                    </CRow>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>

            <CDropdownDivider/>
            <CRow class="text-right mt-3">
              <CCol>
                <CButton class="mr-2" size="sm" color="danger" shape="pill" variant="outline" @click="onDismiss">
                  <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-ban" size="lg"/> CANCEL </span>
                </CButton>
                <CButton size="sm" color="success" shape="pill" variant="outline" @click="onSubmit">
                  <span class="font-weight-bold pr-1 pl-1"><CIcon name="cil-save" size="lg"/> SUBMIT </span>
                </CButton>
              </CCol>
            </CRow>

          </CCardBody>
        </CCard>
      </template>
      <template #footer-wrapper>
        <div class=""></div>
      </template>
    </CModal>
  </div>
</template>

<script>

import {mapGetters} from 'vuex'
import Organization from "@/projects/views/E-Performances/Organization/index.vue";

export default {
  name: 'MethodAssessment',
  components: {Organization},
  props: {
    item: {
      type: Array,
      default: []
    },
    disable: {
      type: Boolean,
      default: false
    },
    dialog: {
      type: Boolean,
      default: false
    },

  },
  data: function () {
    return {
      errModal: false,
      dialog: {
        title: "",
        color: "info",
        message: ""
      },

      data :{
        methods:{}
      },

      option:{
        methods:[
          {
            label:"-",
            value:{
              title:"-",
              value : [],
              subTitle : "Setting",
              control : []
            }
          },
          {
            label:"MPL",
            value:{
              title:"MPL",
              value : [
                {
                  type : 'number',
                  title : "MCQ",
                  value : 0
                },
                {
                  type : 'number',
                  title : "CRQ",
                  value : 0
                },
                {
                  type : 'number',
                  title : "ESSAY",
                  value : 0
                },
                {
                  type : 'number',
                  title : "LAB",
                  value : 0
                },
                {
                  type : 'number',
                  title : "OSCE",
                  value : 0
                }
              ],
              subTitle : "Setting",
              control : [
                {
                  type : 'number',
                  title : "Medium",
                  value : 40,
                  color : ""
                },
                {
                  type : 'number',
                  title : "Medium",
                  value : 60,
                  color : ""
                },
                {
                  type : 'number',
                  title : "Average",
                  value : 80,
                  color : ""
                },
              ]
            }
          },
          {
            label:"P2P",
            value:{
              title:"P2P",
              value : [
                {
                  type : 'number',
                  title : "DEFUALT",
                  value : 0
                },
                {
                  type : 'number',
                  title : "MAX",
                  value : 9
                }
              ],
              subTitle : "Setting",
              control : [
                {
                  type : 'number',
                  title : "Medium",
                  value : 40
                },
                {
                  type : 'number',
                  title : "Medium",
                  value : 60
                },
                {
                  type : 'number',
                  title : "Average",
                  value : 80
                },
              ],
            }
          },
          {
            label: "360",
            value: {
              title : "360",
              value : [
                {
                  type : 'number',
                  title : "DEFUALT",
                  value : 0
                },
                {
                  type : 'number',
                  title : "MAX",
                  value : 25
                }
              ],
              subTitle : "Setting",
              control : [
                {
                  type : 'number',
                  title : "Medium",
                  value : 40
                },
                {
                  type : 'number',
                  title : "Medium",
                  value : 60
                },
                {
                  type : 'number',
                  title : "Average",
                  value : 80
                },
              ],
            }
          },
          {
            label: "Attendance",
            value: {
              title : "Attendance",
              value : [
                {
                  type : 'number',
                  title : "DEFUALT",
                  value : 0
                },
                {
                  type : 'number',
                  title : "MAX",
                  value : 0
                }
              ],
              subTitle : "Setting",
              control : [
                {
                  type : 'number',
                  title : "Medium",
                  value : 0
                },
                {
                  type : 'number',
                  title : "Medium",
                  value : 80
                }
              ],
            }
          }
        ]
      },
      methods: [],

      dfields:[{
        key:"code",
        label:"Code"
      }]
    }
  },
  mounted() {
  },

  created() {
  },

  beforeDestroy() {

  },

  methods: {
    onDismiss(){
      // console.log(this.$parent.$parent)
      this.$props.dialog = false;
    },

    onSubmit(){
      this.onDismiss()
    },

    onSelectMethod(value, e) {

      this.$props.item.methods.pop()
      this.$props.item.methods.push(value);

      // set fields from change select method //

      // var fields = this.dfields
      var fields = [
        {key: "no", label: "#",  _style: 'width:50px; text-align: center'},
        {key:"avata", label:"", _style: 'width:50px; text-align: center'},
        {key:"members", label:"Member"},

        {key: "section", label: "Section",  _style: 'width:50px; text-align: center'},
      ]


      // defualt


      for(var i=0; i<value.value.length; i++){
        if( value.value[i].title != "DEFUALT"){

          var objs = {};
          objs.key = value.value[i].title.toLowerCase();
          objs.label = value.value[i].title;
          fields.push(objs)
        }
      }

      this.$props.item.fields = fields;



    },


  },
  computed: {

    ...mapGetters({

    })
  },

  watch: {

  }
}
</script>

<style>
.w50{
  min-width: 50%;
}
.input-group-append .form-group {
  margin-bottom: 0px;
}
.text-right{
  text-align: end;
}
</style>
